"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toErrorMessage = exports.toError = exports.isError = void 0;
const is_string_1 = require("./is-string");
const stringify_1 = require("./stringify");
function isError(error) {
    return error instanceof Error;
}
exports.isError = isError;
function toError(error) {
    if (isError(error))
        return error;
    try {
        return new Error((0, is_string_1.isString)(error) ? error : (0, stringify_1.stringify)(error));
    }
    catch {
        return new Error(String(error));
    }
}
exports.toError = toError;
function toErrorMessage(error) {
    return toError(error).message;
}
exports.toErrorMessage = toErrorMessage;
//# sourceMappingURL=to-error.js.map